import { render, staticRenderFns } from "./RefundAttachments.vue?vue&type=template&id=0f8802d8&scoped=true"
import script from "./RefundAttachments.vue?vue&type=script&lang=js"
export * from "./RefundAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8802d8",
  null
  
)

export default component.exports